import { useIntl } from "react-intl";
import Button from "components/v2/Button/Button";
import { HandleClickRequestApprovalParams } from "../hooks/useApprovalFlowDialogs";

interface QuotationFooterSecondaryActionsProps {
  showEditAndCancelButtons?: boolean;
  showSuggestApprovalButton?: boolean;
  handleClickRequestApproval: (params: HandleClickRequestApprovalParams) => void;
  handleClickEditManualQuote: () => void;
  handleClickCancelManualQuote: () => void;
}

export default function QuotationFooterSecondaryActions({
  showEditAndCancelButtons,
  showSuggestApprovalButton,
  handleClickRequestApproval,
  handleClickEditManualQuote,
  handleClickCancelManualQuote,
}: QuotationFooterSecondaryActionsProps) {
  const intl = useIntl();
  return (
    <>
      {showEditAndCancelButtons && (
        <>
          <Button
            label={intl.formatMessage({
              id: "quote.quotation.editQuote",
              defaultMessage: "Edit quote",
            })}
            variant="secondary-color"
            onClick={handleClickEditManualQuote}
          />
          <Button
            label={intl.formatMessage({
              id: "quote.cancelQuote",
              defaultMessage: "Cancel quote",
            })}
            variant="error"
            onClick={handleClickCancelManualQuote}
          />
        </>
      )}
      {showSuggestApprovalButton && (
        <Button
          label={intl.formatMessage({
            id: "shipment-quotes.components.quotes.suggestApproval",
            defaultMessage: "Suggest approval",
          })}
          variant="secondary-color"
          onClick={() => handleClickRequestApproval({ isSuggestApproval: true })}
        />
      )}
    </>
  );
}

QuotationFooterSecondaryActions.defaultProps = {
  showEditAndCancelButtons: false,
  showSuggestApprovalButton: false,
};
